import { FollowIcon, FollowedIcon, UnfollowIcon } from '../../Brand/Icon';
import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'antd';
import api from '../../../services';
import { getUser } from '../../../utils/func';
import { APP_ROUTES } from '../../../utils/constant';
import url from '../../../utils/url';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './index.scss';

const { userFollowsAdd, userFollowsDelete } = api;

export default function ButtonSubscribe({
  user_id,
  initialIsFollowing = false,
  onFollowChange,
  onFollowError,
  onRequestUnfollow,
  readOnlyFollowing = false,
  personName,
  isLoading,
  disabled = false
}) {
  const { t } = useTranslation();
  let storageUser = getUser();
  const navigate = useNavigate();
  const pending = useRef(false);
  const generation = useRef(0);
  const [busy, setBusy] = useState(false);
  const [isFollowing, setIsFollowing] = useState(initialIsFollowing);

  useEffect(() => {
    setIsFollowing(initialIsFollowing);
  }, [initialIsFollowing, user_id]);

  useEffect(() => {
    generation.current += 1;
    pending.current = false;
    setBusy(false);
    return () => { generation.current += 1; };
  }, [user_id]);

  const handleFollowToggle = async () => {
    if (storageUser == null) {
      navigate(url(APP_ROUTES.LOGIN));
      return false;
    }
    
    if (disabled || isLoading || pending.current || !user_id || (readOnlyFollowing && isFollowing)) return false;
    pending.current = true;
    const request = generation.current;
    setBusy(true);
    try {
      const response = isFollowing ? await userFollowsDelete({ id: user_id }) : await userFollowsAdd({ id: user_id });
      if (request !== generation.current) return false;
      if (response?.statusCode !== 200 || response.success === false) throw new Error('Follow unavailable');
      setIsFollowing(!isFollowing);
      onFollowChange?.(!isFollowing);
      return true;
    } catch {
      if (request === generation.current) onFollowError?.();
      return false;
    } finally {
      if (request === generation.current) { pending.current = false; setBusy(false); }
    }
  };

  const label = isFollowing ? t('brand:unfollowAction', { defaultValue: 'Unfollow' }) : t('brand:followAction', { defaultValue: 'Follow' });
  if (isFollowing && readOnlyFollowing) return <span className="follow-status" role="img"
    aria-label={t('brand:followingPerson', { name: personName })}><FollowedIcon className="nav-icon" /></span>;

  const handleClick = () => {
    if (storageUser && isFollowing && onRequestUnfollow) {
      const request = generation.current;
      onRequestUnfollow(() => request === generation.current ? handleFollowToggle() : Promise.resolve(false));
    } else handleFollowToggle();
  };

  return (
    <Button className="button-follow"
      aria-label={personName ? `${label}: ${personName}` : label}
      aria-pressed={isFollowing}
      onClick={handleClick}
      disabled={disabled || isLoading || busy}
      aria-busy={busy}
    >
      {isFollowing ? (
        <UnfollowIcon className="nav-icon" />
      ) : (
        <FollowIcon className="nav-icon" />
      )}
    </Button>
  )
}
